/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

var ReactDOMClient = require('react-dom/client');
var modalRoot;

/*
 * Opens the given modal component by rendering it on an element appended to the document body. Example usage:
 *
 * modal.open(<MyModal arg='value'/>);
 * ...
 * modal.close();
 */
exports.open = function (modal) {
  var modalContainer = document.createElement('div');
  modalContainer.id = 'modal-container';
  document.body.appendChild(modalContainer);
  modalRoot = ReactDOMClient.createRoot(modalContainer);
  if (modalRoot) modalRoot.render(modal);
};

/*
 * Closes the modal that is currently open by unmounting and removing it from the document body.
 */
exports.close = function () {
  var modalContainer = document.getElementById('modal-container');
  if (modalContainer) {
    // setTimeout workaround for https://github.com/facebook/react/issues/3298
    setTimeout(function () {
      if (modalRoot) modalRoot = modalRoot.unmount();
      if (modalContainer.parentNode) {
        modalContainer.parentNode.removeChild(modalContainer);
      }
    }, 0);
  }
};